var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.waiter)?_c('div',{staticClass:"extras"},[_vm._m(0),_c('WaiterForm',{attrs:{"saving":_vm.saving,"waiter":_vm.waiter},on:{"save":_vm.save}})],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breadcrumbs"},[_c('h2',[_vm._v("Edit")])])
}]

export { render, staticRenderFns }